import { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'

import { useScrollToTop } from 'src/v3/utilities/hooks/use-scroll-to-top'
import QuizAnalyticsTabs, {
  QUIZ_ANALYTICS_TABPANEL_ID,
  quizAnalyticsTabID,
  useQuizAnalyticsTab,
} from './quiz-analytics-tabs'

// Shared shell for the Overview and Learners pages: one h1, the tab bar,
// and the tabpanel the active tab controls.
export default function QuizAnalyticsTabbedPage({
  children,
}: {
  children: ReactNode
}) {
  let activeTab = useQuizAnalyticsTab()

  useScrollToTop()

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box className="flex flex-col gap-6">
        <Typography variant="h5" component="h1">
          Quiz Analytics
        </Typography>
        <QuizAnalyticsTabs />
        <Box
          role="tabpanel"
          id={QUIZ_ANALYTICS_TABPANEL_ID}
          aria-labelledby={quizAnalyticsTabID(activeTab)}
        >
          {children}
        </Box>
      </Box>
    </Container>
  )
}
